module.exports = __webpack_public_path__ + "static/media/click@2x.116eaeea.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/click@2x.png
// module id = 822
// module chunks = 0